<template>
  <b-container>
    <h1>{{ $t("tracking.vehicleType.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>

    <b-form @submit.prevent="save">
      <b-row>
        <b-col sm="12" md="6" lg="6">
          <vehicle-type-crud-data
            :model="model"
            :modelstate="modelstate"
            :readonly="false"
            class="mb-4"
          >
          </vehicle-type-crud-data>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button type="submit" :disabled="submitted">
            {{ $t("geral.save") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "VehicleTypeCreate",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    VehicleTypeCrudData: () =>
      import("@/components_rms/tracking/vehicleType/VehicleTypeCrudData.vue"),
  },
  props: {
    companyId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      modelstate: [],
      model: {},
    };
  },
  created() {
    this.newModel();
  },
  computed: {
      getUrlBackToList() {
          if (this.companyId) {
            return `../vehicleType/list/${companyId}`;
          }
          return `../vehicleType/list`;
      }
  },
  methods: {
    newModel() {
      this.model = {
        // companyId: null,
        vehicleTypeId: 0,
        vehicleTypeActive: true,
        vehicleTypeDescription: "",
        vehicleTypeName: "",
      };
    },
    save() {
      this.submitted = true;
      this.$api
        .post("/vehicleType/create", this.model)
        .then((response) => {
          this.newModel();
          this.$refs.alert.show();
          this.modelstate = [];
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = [];
          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
            } else {
              if (error.response.data) {
                this.alert.error = error.response.data.errors;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.fadeAlertDanger.show();
        });
    },
  },
};
</script>
